import domReady from '@wordpress/dom-ready'
import { render, useEffect } from '@wordpress/element'
import { Servicepoints } from "./servicepoints";
import { DeliveryTimes } from "./delivery-times";
import { SameDay } from "./same-day";
import { __ } from '@wordpress/i18n';
import { useState } from '@wordpress/element'

domReady(async function () {
    const getElementByIdAsync = id => new Promise(resolve => {
        const getElement = () => {
            const element = document.getElementById(id)
            if(element) {
                resolve(element)
            } else {
                requestAnimationFrame(getElement)
            }
        };
        getElement()
    });

    const container = await getElementByIdAsync('dhlpwc-app')
    render(<App/>, container)
})

export const App = () => {
    const [postalCode, setPostalCode] = useState(window.dhlpwc_block_data['postal_code'])
    const [countryCode, setCountryCode] = useState(window.dhlpwc_block_data['country_code'])
    const [selectedShippingMethod, setSelectedShippingMethod] = useState(window.dhlpwc_block_data['initial_shipping_method'])
    const [validationClass, setValidationClass] = useState('dhlpwc_warning')

    // Only run this once, intentionally no dependencies given
    useEffect(()=>{

        // Track selected shipping method
        document.addEventListener( "change", trackSelectedShippingMethod );
        function trackSelectedShippingMethod(event){
            let element = event.target;
            if (element.name === 'radio-control-0') {
                setSelectedShippingMethod(event.target.value)
            }
        }

        /**
         * Create observer for when shipping methods fundamentally change (WooCommerce does not call the Change method)
         * We observe the parent of the radio buttons. When a shipping methods gets added or removed, we update the selectedShippingMethod
         */
        const observer = new MutationObserver((mutationList) => {
            for (const mutation of mutationList) {
                if (mutation.type === "childList") {
                    let radioControlElement = document.getElementsByName('radio-control-0')
                    if (typeof radioControlElement !== "undefined" && typeof radioControlElement[0] !== "undefined" && typeof radioControlElement[0].value !== "undefined") {
                        setSelectedShippingMethod(radioControlElement[0].value)
                    }
                }
            }
        });
        const radioControlElement = document.getElementsByName('radio-control-0')
        // TODO clean up check
        if (typeof radioControlElement !== "undefined" && typeof radioControlElement[0] !== "undefined" && typeof radioControlElement[0].parentElement !== "undefined" && typeof radioControlElement[0].parentElement.parentElement !== "undefined") {
            observer.observe(radioControlElement[0].parentElement.parentElement, {childList: true});
        }

        // TODO find a better method to retrieve address data instead of observing requests
        const nativeFetch = window.fetch
        window.fetch = function(...args) {
            let isWantedCall = false
            const urlParams = new URLSearchParams(args[0])
            urlParams.forEach(function (param) {
                if (isWantedCall) {
                    return
                }

                if (param.includes('batch')) {
                    isWantedCall = true
                }
            });

            if (!isWantedCall) {
                return nativeFetch.apply(window, args);
            }

            JSON.parse(args[1].body).requests.forEach((request) => {
                if (request.path.includes('update-customer')) {
                    if (typeof request.body.shipping_address.country !== 'undefined') {
                        setCountryCode(request.body.shipping_address.country)
                    }

                    if (typeof request.body.shipping_address.postcode !== 'undefined') {
                        setPostalCode(request.body.shipping_address.postcode);
                    }
                }
            })

            return nativeFetch.apply(window, args);
        }
    }, [])

    const deliveryTimeShippingMethods = [
        'dhlpwc-parcelshop',
        'dhlpwc-home',
        'dhlpwc-home-evening',
        'dhlpwc-home-next-day',
        'dhlpwc-home-no-neighbour',
        'dhlpwc-home-no-neighbour-evening',
        'dhlpwc-home-no-neighbour-next-day',
    ]

    useEffect(() => {
        const deliveryOptionsElement = document.getElementById('dhlpwc-shipping-method-delivery-options')
        if (!deliveryOptionsElement) {
            return
        }
        if (deliveryTimeShippingMethods.indexOf(selectedShippingMethod) !== -1) {
            deliveryOptionsElement.style.display = "block"
        } else {
            deliveryOptionsElement.style.display = "none"
        }
    }, [selectedShippingMethod])

    return <div id='dhlpwc-shipping-method-delivery-options' className='dhlpwc-shipping-method-delivery-options'>
        <div className="dhlpwc-delivery-options-header">{__('DHL Delivery options')}</div>
        <DeliveryTimes
            postalCode={postalCode}
            countryCode={countryCode}
            selectedShippingMethod={selectedShippingMethod}
        />
        <Servicepoints
            postalCode={postalCode}
            countryCode={countryCode}
            selectedShippingMethod={selectedShippingMethod}
            validationClass={validationClass}
            setValidationClass={setValidationClass}
        />
        <SameDay
            postalCode={postalCode}
            countryCode={countryCode}
            selectedShippingMethod={selectedShippingMethod}
        />
    </div>
}
